import gql from "graphql-tag";

export default gql`
  query ValidateReferralCode($code: String!) {
    validateReferralCode(code: $code) {
      isValid
      referrerName
      reason
    }
  }
`;
